import { render, staticRenderFns } from "./TemplateDrawer.vue?vue&type=template&id=378636f7"
import script from "./TemplateDrawer.vue?vue&type=script&lang=js"
export * from "./TemplateDrawer.vue?vue&type=script&lang=js"
import style0 from "./TemplateDrawer.vue?vue&type=style&index=0&id=378636f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports